import { validate } from 'zod/mini';
import type { core } from 'zod/mini';

export const getFormRequiredFields = (
    validationSchema: unknown,
): Record<string, { required: boolean }> => {
    const schema = typeof validationSchema === 'function' ? validationSchema() : validationSchema;
    const shape = (schema as { shape?: Record<string, core.$ZodType> } | undefined)?.shape;
    if (!shape) {
        return {};
    }

    return Object.fromEntries(
        Object.entries(shape).map(([name, fieldSchema]) => [
            name,
            { required: !validate(fieldSchema, undefined) && !validate(fieldSchema, null) },
        ]),
    );
};
